import {useCallback, useState} from 'react';
import type {Job} from '@cp/model';
import {jobCreateStudyGeneration} from '../../api/callable/jobs';

export function useCreateStudyGenerationJob() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const createStudyGenerationJob = useCallback(async (moduleId: string, topics?: string[]): Promise<Job> => {
    setLoading(true);
    setError(undefined);
    try {
      return await jobCreateStudyGeneration({moduleId, topics});
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    createStudyGenerationJob,
    loading,
    error,
  };
}
